export enum RoleCodes {
  Member = '1',
  Admin = '2',
  RSIStaff = '9',
  AvailabilityOnly = '124',
}
